export const CONNECT = 'connect';
export const ON_VISIT = 'onVisit';
export const ON_PROJECT_START = 'onProjectStart';
export const ON_PROJECT_RESTART = 'onProjectRestart';
export const ON_PROJECT_PAUSE = 'onProjectPause';
export const ON_PROJECT_DEACTIVATE = 'onProjectDeactivate';
